var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "24",
      "y": "24.9883",
      "width": "24",
      "height": "24",
      "rx": "12",
      "transform": "rotate(-180 24 24.9883)",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.07505 13.6493L5.53753 13.1118L5 13.6493L5.53753 14.1868L6.07505 13.6493ZM19 7.56697C19 7.36533 18.9199 7.17195 18.7773 7.02936C18.6347 6.88678 18.4414 6.80668 18.2397 6.80668C18.0381 6.80668 17.8447 6.88678 17.7021 7.02936C17.5595 7.17195 17.4794 7.36533 17.4794 7.56697L19 7.56697ZM9.33898 9.31032L5.53753 13.1118L6.61258 14.1868L10.414 10.3854L9.33898 9.31032ZM5.53753 14.1868L9.33898 17.9883L10.414 16.9132L6.61258 13.1118L5.53753 14.1868ZM6.07505 14.4096L13.678 14.4096L13.678 12.889L6.07505 12.889L6.07505 14.4096ZM19 9.08755L19 7.56697L17.4794 7.56697L17.4794 9.08755L19 9.08755ZM13.678 14.4096C15.0895 14.4096 16.4431 13.8489 17.4412 12.8508C18.4393 11.8527 19 10.499 19 9.08755L17.4794 9.08755C17.4794 10.0958 17.0789 11.0627 16.366 11.7756C15.6531 12.4885 14.6862 12.889 13.678 12.889L13.678 14.4096Z",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.53753 13.1118L6.07505 13.6493L5.53753 14.1868M5.53753 13.1118L5 13.6493L5.53753 14.1868M5.53753 13.1118L9.33898 9.31032L10.414 10.3854L6.61258 14.1868L5.53753 13.1118ZM5.53753 14.1868L9.33898 17.9883L10.414 16.9132L6.61258 13.1118L5.53753 14.1868ZM19 7.56697C19 7.36533 18.9199 7.17195 18.7773 7.02936C18.6347 6.88678 18.4414 6.80668 18.2397 6.80668C18.0381 6.80668 17.8447 6.88678 17.7021 7.02936C17.5595 7.17195 17.4794 7.36533 17.4794 7.56697M19 7.56697L17.4794 7.56697M19 7.56697L19 9.08755M17.4794 7.56697L17.4794 9.08755M13.678 14.4096L6.07505 14.4096L6.07505 12.889L13.678 12.889M13.678 14.4096L13.678 12.889M13.678 14.4096C15.0895 14.4096 16.4431 13.8489 17.4412 12.8508C18.4393 11.8527 19 10.499 19 9.08755M13.678 12.889C14.6862 12.889 15.6531 12.4885 16.366 11.7756C17.0789 11.0627 17.4794 10.0958 17.4794 9.08755M19 9.08755L17.4794 9.08755",
      "stroke": "white",
      "stroke-width": "0.5"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }